export class UnitOfMeasurementValidator {
  public static validate(input: string): boolean {
    return input.toLowerCase() === 'in' || input.toLowerCase() === 'mm';
  }
}
